// TODO: Import React module
import React, { useState, useEffect, } from 'react';
import { useSearchParams } from 'react-router-dom';

// TODO: Import MUI module
import {
    Box, Button, Container, ImageList, ImageListItem, ImageListItemBar,
    Switch, Typography, Grid,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// TODO: Import MUI icon
import { } from '@mui/icons-material';

// TODO: Import context
import { Context, WebservicesYiYuan } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import PlantInfo from './PlantInfo';

const Garden = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Garden Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const cols = isXs ? 1 : isSm ? 2 : isMd ? 2 : 3;

    const [searchParams] = useSearchParams();
    const defaultPlant = searchParams.get('plant');

    const [filter, setFilter] = useState(
        {
            ornamental: false,
            succulent: false,
            fruit: false,
            spices: false,
            vegetable: false,
            cereal: false,
            tree: false,
            herbs: false
        },
    );

    const [plant, setPlant] = useState(defaultPlant);

    const [images, setImages] = useState([]);

    // TODO: Define event
    const getPlants = () => {
        (async () => {
            let conditions = [];

            Object.keys(filter).forEach(key => {
                if (filter[key]) {
                    conditions.push(key);
                }
            });

            const formData = new FormData();
            formData.append('action', 'GetPlants');
            formData.append('conditions', conditions);

            fetch(WebservicesYiYuan, { method: 'POST', body: formData, })
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    if (result.length > 0) {
                        setImages(result);
                    }
                })
                .catch((error) => { console.error('Error:', error); });
        })();
    }

    const handleChecked = (type) => {
        let object = { ...filter };
        object[type] = !object[type];
        setFilter(filter => ({ ...object }));
    };

    const handleClickOpen = (id) => {
        //window.open('./CD_BlessedBotanicalsPlant?id=' + id + '#BoxFirst', '_blank');
        setPlant(id);
    };

    useEffect(getPlants, [filter]);

    // TODO: Return component
    return (
        <Box id="Garden" sx={{ py: 4, }}>
            <PlantInfo plant={plant} setPlant={setPlant} />
            <Container>
                <Typography
                    align="center"
                    gutterBottom
                    sx={{ color: 'success.dark', fontWeight: 'bold', textAlign: 'center', }}
                    variant="h4"
                >
                    {Text.CampusDevelopment.BlessedBotanicals.Garden.Title[language]}
                </Typography>
                <Typography variant="body1" paragraph>
                    貽園雖小，卻蘊藏豐富生態。在這片別緻的園地中，我們精心培育了超過40種特色植物，包括食用香草、藥用植物與觀賞花卉。麻雀雖小五臟俱全，這裡既是教學活教材，也是社區共享的療癒角落，展現都市中難能可貴的生物多樣性。
                </Typography>
                <Grid container spacing={1}>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.ornamental}
                            color="success"
                            onClick={() => { handleChecked('ornamental'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🌼觀賞
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.succulent}
                            color="success"
                            onClick={() => { handleChecked('succulent'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🌵多肉
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.fruit}
                            color="success"
                            onClick={() => { handleChecked('fruit'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🍎水果
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.spices}
                            color="success"
                            onClick={() => { handleChecked('spices'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🧂香料
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.vegetable}
                            color="success"
                            onClick={() => { handleChecked('vegetable'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🥬蔬菜
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.cereal}
                            color="success"
                            onClick={() => { handleChecked('cereal'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🌾殼類
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.tree}
                            color="success"
                            onClick={() => { handleChecked('tree'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🌳樹木
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Switch
                            checked={filter.herbs}
                            color="success"
                            onClick={() => { handleChecked('herbs'); }}
                        />
                        <Typography
                            component="span"
                            gutterBottom
                            variant="body2"
                        >
                            🌿草藥
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <Button
                            color="success"
                            onClick={() => {
                                let object = { ...filter };
                                object['ornamental'] = false;
                                object['succulent'] = false;
                                object['fruit'] = false;
                                object['spices'] = false;
                                object['vegetable'] = false;
                                object['cereal'] = false;
                                object['tree'] = false;
                                object['herbs'] = false;
                                setFilter(filter => ({ ...object }));
                            }}
                            sx={{ lineHeight: '1rem' }}
                            variant="contained"
                        >
                            清除篩選
                        </Button>
                    </Grid>
                </Grid>
                <ImageList cols={cols} gap={16} sx={{ gridAutoRows: '240px', }}>
                    {images.map((image) => (
                        <ImageListItem
                            key={image.ID}
                            onClick={() => handleClickOpen(image.ID)}
                            sx={{
                                '&:hover img': { filter: 'brightness(1.3)', transition: 'all 0.3s ease', },
                                cursor: 'pointer',
                            }}
                        >
                            <img
                                src={`https://www.pohtyh.edu.hk/YiYuan/images/plants/${image.ID}/cover.jpg`}
                                alt={image.Name}
                                loading="lazy"
                                style={{
                                    borderRadius: 16,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    filter: image.Alive === '0' ? 'grayscale(80%)' : 'none',
                                }}
                            />
                            <ImageListItemBar
                                sx={{ borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}
                                title={image.Alive === '0' ?
                                    <>
                                        <Typography component="span" variant="body1">{image.Name}</Typography>
                                        <Typography component="span" variant="body2">{`(暫別貽園)`}</Typography>
                                    </> :
                                    <Typography sx={{ mr: 2 }} variant="body1">{image.Name}</Typography>}
                                actionIcon={
                                    <Typography sx={{ mr: 2 }} variant="body1">
                                        {parseInt(image.Ornamental) === 1 && '🌼'}
                                        {parseInt(image.Succulent) === 1 && '🌵'}
                                        {parseInt(image.Fruit) === 1 && '🍎'}
                                        {parseInt(image.Spices) === 1 && '🧂'}
                                        {parseInt(image.Vegetable) === 1 && '🥬'}
                                        {parseInt(image.Cereal) === 1 && '🌾'}
                                        {parseInt(image.Tree) === 1 && '🌳'}
                                        {parseInt(image.Herbs) === 1 && '🌿'}
                                    </Typography>
                                }
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Container>
        </Box>
    );
};

export default Garden;